import React from "react";

import {DateField, ReferenceField, RichTextField, Show, Tab, TabbedShowLayout, TextField} from "react-admin";

const PageShow = (props) => (
    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="Résumé pour liste">
                <TextField source="abstract_title" label="Titre"/>
                <RichTextField source="abstract_content" label="introduction pour liste"/>
            </Tab>

            <Tab label="Page contenu">
                <TextField source="title" label="Titre"/>
                <RichTextField source="content" label="Contenu initial"/>
            </Tab>

            <Tab label="Bouton">
                <TextField source="button_text" label="Texte"/>
                <TextField source="button_url" label="Url de destination"/>
                <TextField source="button_icon" label="Icone"/>
            </Tab>

            <Tab label="Configuration">
                <TextField source="meta_title" label="Titre SEO"/>
                <TextField source="url" label="URL de la page"/>
                <ReferenceField label="Catégorie" source="category_id" reference="page_category">
                    <TextField source="name"/>
                </ReferenceField>
                <DateField source="created_date" label="Date de création"/>
                <DateField source="updated_date" label="Date de dernière modification"/>
            </Tab>
        </TabbedShowLayout></Show>
);

export default PageShow;
